const en = {
    views: {
        home: {
            repositoryName: 'Repository name',
            search: 'Search',
            title: 'Azertiumit exercise',
        },
    },
};

export default en;
